var api_url = '';

switch (process.env.NODE_ENV) {
  case 'development':
    api_url = 'https://localhost:44360';
    break;
  case 'production':
    //api_url = 'http://t2witweb01.nina.no/InnkryssingLaks/api';
    api_url = 'https://innkryssinglaks.nina.no/api';
    break;
}

export const INNKRYSSING_CONFIG = {
  API_URL: api_url
};
